export default class ThemeVideoModalController {
	constructor() {
		this.initialized = false;
		this.handleDocumentClick = this.handleDocumentClick.bind(this);
	}

	init() {
		if (this.initialized) {
			return;
		}

		this.initialized = true;
		this.exposeGlobals();
		document.addEventListener('click', this.handleDocumentClick);
	}

	exposeGlobals() {
		window.openModalVideo = (url) => this.openModalVideo(url);
		window.closeModalVideo = () => this.closeModalVideo();
		window.showVideo = (url) => this.showCategoryVideo(url);
		window.closeModal = () => this.closeAll();
	}

	handleDocumentClick(event) {
		const closeTrigger = event.target.closest('[data-video-modal-close]');
		if (closeTrigger) {
			event.preventDefault();
			this.closeAll();
			return;
		}

		const categoryOverlay = document.getElementById('video-modal');
		if (categoryOverlay && event.target === categoryOverlay) {
			this.closeCategoryVideo();
		}

		const primaryOverlay = document.getElementById('videoModalVideoYtb');
		if (primaryOverlay && event.target === primaryOverlay) {
			this.closePrimaryVideo();
		}

		const heroOverlay = document.getElementById('tmhq-video-popup');
		if (heroOverlay && event.target === heroOverlay) {
			this.closeHeroVideo();
		}
	}

	openModalVideo(url) {
		if (this.hasHeroVideoModal()) {
			this.openHeroVideo(url);
			return;
		}

		this.openPrimaryVideo(url);
	}

	closeModalVideo() {
		this.closePrimaryVideo();
		this.closeHeroVideo();
	}

	showCategoryVideo(videoUrl) {
		const modal = document.getElementById('video-modal');
		const modalContent = document.getElementById('modal-video-content');

		if (!modal || !modalContent) {
			return;
		}

		modalContent.innerHTML = `<iframe width="100%" height="100%" src="${videoUrl}" style="aspect-ratio: 16/9; padding: 6px; padding-bottom: 0;" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
		modal.style.display = 'block';
	}

	closeCategoryVideo() {
		const modal = document.getElementById('video-modal');
		const modalContent = document.getElementById('modal-video-content');

		if (modal) {
			modal.style.display = 'none';
		}

		if (modalContent) {
			modalContent.innerHTML = '';
		}
	}

	openPrimaryVideo(videoUrl) {
		const modal = document.getElementById('videoModalVideoYtb');
		const iframe = document.getElementById('videoIframe');

		if (!modal || !iframe) {
			return;
		}

		iframe.src = videoUrl;
		modal.style.display = 'block';
	}

	closePrimaryVideo() {
		const modal = document.getElementById('videoModalVideoYtb');
		const iframe = document.getElementById('videoIframe');

		if (iframe) {
			iframe.src = '';
		}

		if (modal) {
			modal.style.display = 'none';
		}
	}

	hasHeroVideoModal() {
		return !!document.getElementById('tmhq-video-popup') && !!document.getElementById('tmhq-video-iframe');
	}

	openHeroVideo(videoUrl) {
		const popup = document.getElementById('tmhq-video-popup');
		const iframe = document.getElementById('tmhq-video-iframe');

		if (!popup || !iframe) {
			return;
		}

		iframe.src = videoUrl;
		popup.style.display = 'flex';
	}

	closeHeroVideo() {
		const popup = document.getElementById('tmhq-video-popup');
		const iframe = document.getElementById('tmhq-video-iframe');

		if (iframe) {
			iframe.src = '';
		}

		if (popup) {
			popup.style.display = 'none';
		}
	}

	closeAll() {
		this.closeCategoryVideo();
		this.closePrimaryVideo();
		this.closeHeroVideo();
	}
}
